export const APP_PREFIX = '/app'
